import { laptopLargeMin, largeTabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import StreetHeader from '@propertypal/shared/src/resources/images/products/street-header.svg';
import styled from 'styled-components';
import ProductsTabs from '../../tabs/ProductsTabs';
import { Heading, SubHeading } from '../../typography';

export const Container = styled.div`
  background-color: rgba(216, 216, 216, 0.2);
  text-align: center;
  display: flex;
  position: relative;
  flex-direction: column;
  overflow: hidden;
`;

export const HeaderContainer = styled.div`
  max-width: 950px;
  margin: 70px auto 0 auto;
  padding: 0 10px;

  ${Heading} {
    margin-bottom: 20px;
  }

  @media screen and (${largeTabletMax}) {
    ${Heading} {
      margin-bottom: 15px;
      font-size: 28px;
    }

    ${SubHeading} {
      font-size: 20px;
    }
  }
`;

export const Tabs = styled(ProductsTabs)`
  width: 100%;
  max-width: fit-content;
  margin: 50px auto 130px auto;
  padding: 0 5px;

  @media (${laptopLargeMin}) {
    margin-bottom: 175px;
  }
`;

export const HeaderImg = styled(StreetHeader)`
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  min-width: 1360px;
  width: 100%;
  justify-self: center;
`;
